import { ReactElement } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

import PageContainer from "~frontend/components/PageContainer";
import { useBreadcrumbs } from "~frontend/providers/BreadcrumbsProvider";

export default function ApiDocumentation(): ReactElement {
  useBreadcrumbs([
    {
      label: "API Keys",
      path: "/organization/api-keys",
    },
    {
      label: "Documentation",
      path: "/organization/api-keys/documentation",
    },
  ]);

  return (
    <PageContainer>
      <SwaggerUI url={`${import.meta.env.STW_API_URL}/api/v1-docs`} />
    </PageContainer>
  );
}
